import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from './components/Dashboard.vue';
import util from './util';
import store from './store';
import $ from 'jquery';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        interno: true,
      }
    },
    {
      path: '/recepcao/info',
      name: 'c-recep-info',
      component: () => import('./components/modulos/callcenter/Informacoes.vue'),
      meta: {
        interno: true,
        perfil: 4,
      }
    },
    {
      path: '/recepcao/envio',
      name: 'protocolo-envio',
      props: true,
      component: () =>
        import('./components/modulos/recepcao/ProtocoloEnvioDaRecepcao.vue'),
      meta: {
        interno: true,
        perfil: 4
      }
    },
    {
      path: '/recepcao/particular',
      name: 'fechamento-particular',
      props: true,
      component: () =>
        import('./components/modulos/financeiro/PrestacaoDeContas.vue'),
      meta: {
        interno: true,
        perfil: 4,
        recepcao: true
      }
    },
    {
      path: '/recepcao/prof-solicitante',
      name: 'r-medico-solicitante',
      props: true,
      component: () => import('./components/cadastros/items/CadastroMedicoSolicitante.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Recepção',
        perfil: 4,
        recepcao: true
      }
    },
    {
      path: '/qrcode/:id_unidade_operacao',
      name: 'qrcode',
      props: true,
      component: () =>
        import('./components/painel/QRCodeCheckIn.vue'),
      meta: {
        interno: true,
        perfil: 4
      }
    },
    {
      path: '/call-center/confirmacao',
      name: 'confirmacao',
      component: () =>
        import('./components/modulos/callcenter/Confirmacao.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 3,
      }
    },
    {
      path: '/call-center/info',
      name: 'c-info',
      component: () => import('./components/modulos/callcenter/Informacoes.vue'),
      meta: {
        interno: true,
        perfil: 3,
      }
    },
    {
      path: '/call-center/valores',
      name: 'c-valores',
      component: () => import('./components/modulos/callcenter/ValorPrevisto.vue'),
      meta: {
        interno: true,
        perfil: 3,
      }
    },
    {
      path: '/call-center/bloqueio',
      name: 'bloqueio',
      component: () => import('./components/modulos/callcenter/Bloqueio.vue'),
      meta: {
        interno: true,
        perfil: 3,
      }
    },
    {
      path: '/call-center/listaespera',
      name: 'listaespera',
      component: () => import('./components/modulos/callcenter/ListaEspera.vue'),
      meta: {
        interno: true,
        perfil: 3,
      }
    },
    {
      path: '/call-center/mapasala',
      name: 'mapasala',
      component: () => import('./components/modulos/callcenter/MapaDeSala.vue'),
      meta: {
        interno: true,
        perfil: 3,
      }
    },
    {
      path: '/recepcao/mapasala',
      name: 'rmapasala',
      component: () => import('./components/modulos/callcenter/MapaDeSala.vue'),
      meta: {
        interno: true,
        perfil: 4,
      }
    },
    {
      path: '/recepcao/integrar/:numero?',
      name: 'recep_integrar',
      component: () => import('./components/modulos/recepcao/ObterAtendimentoTerceiro.vue'),
      meta: {
        interno: true,
        perfil: 4,
      }
    },
    {
      path: '/recepcao/checkin',
      name: 'cerimonial-check-in',
      component: () => import('./components/modulos/recepcao/CerimonialCheckIn.vue'),
      meta: {
        interno: true,
        perfil: 4,
      }
    },
    {
      path: '/cerimonial',
      name: 'cerimonial',
      component: () => import('./components/modulos/recepcao/CerimonialCheckIn.vue'),
      meta: {
        interno: true,
        perfil: 28,
      }
    },
    {
      path: '/delegacao',
      name: 'delegacao',
      component: () => import('./components/shared/Delegacao.vue'),
      meta: {
        interno: true,
        perfil: 7,
      }
    },
    {
      path: '/consultorio/mapa',
      name: 'cmapasala',
      component: () => import('./components/modulos/callcenter/MapaDeSala.vue'),
      meta: {
        interno: true,
        perfil: 7,
        consultorio: true,
      }
    },
    {
      path: '/consultorio/agendas',
      name: 'cagendas',
      component: () => import('./components/modulos/consultorio/AgendasConsultorio.vue'),
      meta: {
        interno: true,
        perfil: 7,
        consultorio: true,
      }
    },
    {
      path: '/consultorio/apuracao',
      name: 'consultorio-apuracao',
      component: () => import('./components/modulos/consultorio/ApuracaoRepasseMedico.vue'),
      meta: {
        interno: true,
        perfil: 7,
      }
    },
    {
      path: '/recepcao/apuracao',
      name: 'c-recep-repasse',
      component: () => import('./components/modulos/consultorio/ApuracaoRepasseMedico.vue'),
      meta: {
        interno: true,
        perfil: 4,
      }
    },
    {
      path: '/consultorio/config',
      name: 'consultorio-config',
      component: () => import('./components/modulos/consultorio/ConsultorioConfig.vue'),
      meta: {
        interno: true,
        perfil: 7,
      }
    },
    {
      path: '/call-center/orcamento/:id_orcamento?',
      name: 'orcamento',
      component: () => import('./components/modulos/callcenter/Orcamento.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 3,
      }
    },
    {
      path: '/recepcao/orcamento',
      name: 'rorcamento',
      component: () => import('./components/modulos/callcenter/Orcamento.vue'),
      meta: {
        interno: true,
        perfil: 4,
      }
    },
    {
      path: '/consultorio/orcamento/:id_atendimento',
      name: 'corcamento',
      component: () => import('./components/modulos/callcenter/Orcamento.vue'),
      meta: {
        interno: true,
        perfil: 7,
      }
    },
    {
      path: '/recepcao/pendentes',
      name: 'r-pag-pendentes',
      component: () => import('./components/modulos/financeiro/ParticularPagamentosPendentes.vue'),
      meta: {
        interno: true,
        perfil: 4,
      }
    },
    {
      path: '/crm/orcamento/:id_orcamento?',
      name: 'crmorcamento',
      component: () => import('./components/modulos/callcenter/Orcamento.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 15,
      }
    },
    {
      path: '/recepcao/entrega-resultado/:id_paciente?',
      name: 'entrega-resultado',
      component: () => import('./components/modulos/recepcao/EntregaResultado.vue'),
      meta: {
        props: true,
        interno: true,
        perfil: 4,
      }
    },
    {
      path: '/call-center/entrega-resultado',
      name: 'entrega-resultado-cc',
      component: () => import('./components/modulos/recepcao/EntregaResultado.vue'),
      meta: {
        interno: true,
        perfil: 3,
      }
    },
    {
      path: '/call-center/reservas',
      name: 'reservas-cc',
      component: () => import('./components/modulos/callcenter/ListaReservas.vue'),
      meta: {
        interno: true,
        perfil: 3,
      }
    },
    {
      path: '/call-center/pagamentos/:idpaciente?',
      name: 'pagamentos-callcenter',
      component: () => import('./components/modulos/recepcao/AdiantamentoParticular.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 3,
      }
    },
    {
      path: '/recepcao/pagamentos/:idpaciente?',
      name: 'pagamentos',
      component: () => import('./components/modulos/recepcao/AdiantamentoParticular.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 4,
      }
    },
    {
      path: '/call-center/:id_paciente?',
      name: 'call-center',
      props: true,
      component: () => import('./components/modulos/ModuloCallCenter.vue'),
      meta: {
        interno: true,
        perfil: 3,
      }
    },
    {
      path: '/consultorio',
      name: 'consultorio',
      component: () => import('./components/modulos/consultorio/ModuloConsultorio.vue'),
      meta: {
        props: true, 
        interno: true,
        perfil: 7,
      }
    },
    {
      path: '/consultorio/res/:id/:fila?',
      name: 'res',
      component: () => import('./components/modulos/consultorio/PepItem.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 7,
      }
    },
    {
      path: '/assistencia/cons/:id/:fila?',
      name: 'res',
      component: () => import('./components/modulos/consultorio/PepItem.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 14,
      }
    },
    {
      path: '/consultorio/:id/:id_atend?',
      name: 'pep',
      component: () => import('./components/modulos/consultorio/PEP.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 7,
        espera: true, 
      }
    },
    {
      path: '/avulso/:id',
      name: 'avulsores',
      component: () => import('./components/modulos/consultorio/PepItem.vue'),
      props: true,
      meta: {
        interno: true,
        avulso: true, 
      }
    },
    // Financeiro
    {
      path: '/financeiro/:aba?/:id?',
      name: 'financeiro',
      props: true,
      component: () => import('./components/modulos/financeiro/ModuloFinanceiro.vue'),
      meta: {
        interno: true,
        perfil: 5,
      }
    },
    // Contatos
    {
      path: '/contatos',
      name: 'contatos',
      component: () => import('./components/modulos/telefones/AgendaTelefonica.vue'),
      meta: {
        interno: true,
        perfil: 26,
      }
    },
    // Internação
    {
      path: '/internacao/envio',
      name: 'protocolo-envio-int',
      props: true,
      component: () =>
        import('./components/modulos/recepcao/ProtocoloEnvioDaRecepcao.vue'),
      meta: {
        interno: true,
        perfil: 19
      }
    },
    {
      path: '/internacao/:aba?/:id?',
      name: 'internacao',
      props: true,
      component: () => import('./components/modulos/internacao/ModuloDeInternacao.vue'),
      meta: {
        interno: true,
        perfil: 19,
      }
    },
    {
      path: '/internacao/atendimento/res/:id',
      name: 'internacao-res',
      component: () => import('./components/modulos/consultorio/PepItem.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 19,
        internacao: true
      }
    },
    // Suprimentos
    {
      path: '/config/status-estoque-solic',
      name: 'c-status-estoque-solic',
      component: () => import('./components/cadastros/items/CadastroContatoStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'estoqueSolicitacao',
        titulo: 'Solicitação de Suprimentos'
      },
    },

    {
      path: '/config/status-ordem-compra',
      name: 'c-status-ordem-compra',
      component: () => import('./components/cadastros/items/CadastroContatoStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'aquisicaoOrdemCompra',
        titulo: 'Ordem de Compra'
      },
    },

    {
      path: '/suprimentos/confirm-receb',
      name: 'confirm-receb',
      props: true,
      component: () => import('./components/modulos/suprimentos/EstoqueConfirmRecebimento.vue'),
      meta: {
        interno: true,
      }
    },

    {
      path: '/suprimentos/confirm-recebimento',
      name: 'confirm-recebimento',
      props: true,
      component: () => import('./components/modulos/suprimentos/EstoqueConfirmReceb.vue'),
      meta: {
        interno: true,
      }
    },

    {
      path: '/suprimentos/consumo-paciente',
      name: 'consumo-paciente',
      props: true,
      component: () => import('./components/modulos/suprimentos/ConsumoPaciente.vue'),
      meta: {
        interno: true,
        perfil: 10,
      }
    },

    {
      path: '/suprimentos/:aba?/:id?',
      name: 'suprimentos',
      props: true,
      component: () => import('./components/modulos/suprimentos/ModuloSuprimentos.vue'),
      meta: {
        interno: true,
        perfil: 10,
      }
    },

    {
      path: '/redir',
      name: 'redir',
      props: true,
      component: () => import('./components/util/AzRouter.vue'),
      meta: {
        interno: true,
      }
    },

    // Repasse
    {
      path: '/repasse/prestador/:id_medico_repasse/',
      name: 'repasse-prestador-externo',
      component: () => import('./components/portal/RepassePrestador.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Repasse',
      },
    },
    {
      path: '/repasse/:aba?/:id?',
      name: 'repasse',
      props: true,
      component: () => import('./components/modulos/repasse/ModuloRepasse.vue'),
      meta: {
        interno: true,
        perfil: 11,
      }
    },
    // Faturamento
    {
      path: '/faturamento/config',
      name: 'faturamento-config',
      component: () => import('./components/modulos/faturamento/ConfiguracaoFaturamento.vue'),
      meta: {
        interno: true,
        perfil: 8,
      }
    },
    {
      path: '/faturamento/visao',
      name: 'visao-geral-faturamento',
      component: () => import('./components/modulos/faturamento/GuiasVisaoGeral.vue'),
      meta: {
        interno: true,
        perfil: 8,
      }
    },
    {
      path: '/faturamento/guias/:tipo?',
      name: 'guias',
      props: true,
      component: () => import('./components/modulos/faturamento/Guias.vue'),
      meta: {
        interno: true,
        perfil: 8,
      }
    },
    {
      path: '/faturamento/pendencias',
      name: 'guia_pendencias',
      props: true,
      component: () => import('./components/modulos/faturamento/GuiaPendencias.vue'),
      meta: {
        interno: true,
        perfil: 8,
      }
    },
    {
      path: '/faturamento/receb-nao-ident',
      name: 'receb_nao_ident',
      props: true,
      component: () => import('./components/modulos/faturamento/RecebimentoNaoIdentificados.vue'),
      meta: {
        interno: true,
        perfil: 8,
      }
    },
    {
      path: '/faturamento/atendimentos-guias',
      name: 'atendimentos_guias',
      props: true,
      component: () => import('./components/modulos/faturamento/AtendimentoGuias.vue'),
      meta: {
        interno: true,
        perfil: 8,
      }
    },
    {
      path: '/faturamento/faturas',
      name: 'faturas',
      props: true,
      component: () => import('./components/modulos/faturamento/Faturas.vue'),
      meta: {
        interno: true,
        perfil: 8,
      }
    },
    {
      path: '/faturamento/faturas/:id_fatura',
      name: 'fatura',
      props: true,
      component: () => import('./components/modulos/faturamento/Faturas.vue'),
      meta: {
        interno: true,
        perfil: 8,
      }
    },
    {
      path: '/faturamento/retorno',
      name: 'arquivo-retorno',
      component: () => import('./components/modulos/faturamento/ArquivoRetorno.vue'),
      meta: {
        interno: true,
        perfil: 8,
      }
    },
    {
      path: '/faturamento/cancelamentos',
      name: 'autorizar-cancelamentos',
      component: () => import('./components/modulos/faturamento/AutorizarCancelamento.vue'),
      meta: {
        interno: true,
        perfil: 8,
      }
    },
    {
      path: '/faturamento/calendario-envio',
      name: 'calendario-envio',
      component: () => import('./components/modulos/faturamento/OperadorasAEnviar.vue'),
      meta: {
        interno: true,
        perfil: 8,
      }
    },
    {
      path: '/faturamento/notas-fiscais',
      name: 'notas-fiscais',
      component: () => import('./components/modulos/financeiro/NotasFiscais.vue'),
      meta: {
        interno: true,
        faturamento: true, 
        perfil: 8,
      }
    },
    {
      path: '/faturamento/glosas',
      name: 'faturamento-glosas',
      component: () => import('./components/modulos/faturamento/DashGlosas.vue'),
      meta: {
        interno: true,
        perfil: 8,
      }
    },
    {
      path: '/faturamento/creditos',
      name: 'faturamento-creditos',
      component: () => import('./components/modulos/faturamento/CreditoOperadoras.vue'),
      meta: {
        interno: true,
        perfil: 8,
      }
    },
    {
      path: '/faturamento/precos',
      name: 'c-fat-valid-precos-operadora',
      props: true,
      component: () => import('./components/cadastros/validacao/ValidPrecoOperadora.vue'),
      meta: {
        interno: true,
        perfil: 8
      }
    },
    {
      path: '/faturamento/info',
      name: 'c-fat-info',
      props: true,
      component: () => import('./components/modulos/callcenter/Informacoes.vue'),
      meta: {
        interno: true,
        perfil: 8
      }
    },
    {
      path: '/faturamento/ciha',
      name: 'c-fat-cicha',
      props: true,
      component: () => import('./components/modulos/faturamento/ArquivoCiha.vue'),
      meta: {
        interno: true,
        perfil: 8
      }
    },
    {
      path: '/config/status-fatura',
      name: 'c-fatura-status',
      component: () => import('./components/cadastros/items/CadastroContatoStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'fatura',
        titulo: 'Fluxo de Faturas'
      },
    },
    {
      path: '/relatorios',
      name: 'relatorios',
      component: () => import('./components/relatorios/Relatorios.vue'),
      meta: {
        interno: true,
        perfil: 9,
      }
    },
    {
        path: '/relatorios/dashboards',
        name: 'dashboards',
        component: () => import('./components/relatorios/DashboardsList.vue'),
        meta: {
          interno: true,
          perfil: 9,
        }
    },
    {
      path: '/relatorio/editor/:id?',
      name: 'relatorio-editor',
      component: () => import('./components/relatorios/RelatorioEditor.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 9,
      }
    },
    {
      path: '/relatorio/:id',
      name: 'relatorio',
      component: () => import('./components/relatorios/Relatorio.vue'),
      props: true,
      meta: {
        interno: true,
      }
    },
    {
      path: '/dashboard/editor/:id?',
      name: 'dashboard-editor',
      component: () => import('./components/relatorios/DashboardEditor.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 9,
      }
    },
    {
      path: '/dashboard/:id',
      name: 'custom-dashboard',
      component: () => import('./components/relatorios/CustomDashboard.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 9,
      }
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('./components/News.vue'),
      props: true,
      meta: {
        interno: true,
      }
    },

    // Auditoria de Conta

    {
      path: '/auditoria/:aba',
      name: 'auditoria-conta',
      props: true,
      component: () => import('./components/modulos/auditoria/AuditoriaDeConta.vue'),
      meta: {
        interno: true,
        perfil: 31,
      },
    },

    // Rotas de Solicitação de Autorização...

    {
      path: '/autorizacoes/:aba',
      name: 'solic-autoriz',
      props: true,
      component: () => import('./components/modulos/autoriz/ModuloDeAutorizacao.vue'),
      meta: {
        interno: true,
        perfil: 12,
      },
    },

    // Rotas de CRM...

    {
      path: '/crm/:aba?',
      name: 'crm',
      props: true,
      component: () => import('./components/modulos/crm/ModuloCrm.vue'),
      meta: {
        interno: true,
        perfil: 15,
      },
    },

    {
      path: '/config/status-requisicao',
      name: 'c-status-requisicao',
      component: () => import('./components/cadastros/items/CadastroContatoStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'requisicao',
        titulo: 'Captação Requisição'
      },
    },

    {
      path: '/config/status-validacao-prescricao',
      name: 'c-status-valid-prescr',
      component: () => import('./components/cadastros/items/CadastroContatoStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'receita',
        titulo: 'Validação de Prescrição'
      },
    },

    {
      path: '/config/status-cuidado',
      name: 'c-status-cuidado',
      component: () => import('./components/cadastros/items/CadastroContatoStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'cuidadoPaciente',
        titulo: 'Cuidado Coordenado'
      },
    },

    {
      path: '/config/status-retorno',
      name: 'c-status-retorno',
      component: () => import('./components/cadastros/items/CadastroContatoStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'retornoAtendimento',
        titulo: 'Retorno de Atendimento'
      },
    },

    {
      path: '/config/status-solicitante',
      name: 'c-status-solicitante',
      component: () => import('./components/cadastros/items/CadastroContatoStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'medicoSolicitante',
        titulo: 'Contato com Profissional Solicitante'
      },
    },

    // NPS...

    {
      path: '/nps/:aba?',
      name: 'nps',
      component: () => import('./components/modulos/nps/Nps.vue'),
      props: true, 
      meta: {
        interno: true,
        perfil: 17,
      },
    },

    // Tarefas...

    {
      path: '/tarefas/',
      name: 'tarefas',
      component: () => import('./components/shared/tarefa/Tarefa.vue'),
      meta: {
        interno: true,
      },
    },

    {
      path: '/config/status-tarefa',
      name: 'c-status-tarefa',
      component: () => import('./components/cadastros/items/CadastroContatoStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'tarefa',
        titulo: 'Tarefa'
      },
    },
    {
      path: '/config/prioridade-tarefa',
      name: 'c-prioridade-tarefa',
      component: () => import('./components/cadastros/items/CadastroPrioridadeTarefa.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'tarefa',
        titulo: 'Tarefa'
      },
    },
    {
      path: '/config/tipo-alta',
      name: 'c-tipo-alta',
      component: () => import('./components/cadastros/items/CadastroTipoAlta.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'tipoAlta',
        titulo: 'Tipo de Alta'
      },
    },
    {
        path: '/config/tipo-arquivo',
        name: 'c-tipo-arquivo',
        component: () => import('./components/cadastros/items/CadastroTipoArquivo.vue'),
        props: true,
        meta: {
          interno: true,
          breadcrumb: 'Configurações',
          perfil: 6
        }
    },
    {
      path: '/config/cor-tempo-espera',
      name: 'c-tempo-espera-cor',
      component: () => import('./components/cadastros/items/CadastroTempoEsperaCor.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
        path: '/config/servicos-pacs',
        name: 'c-config-pacs',
        component: () => import('./components/cadastros/items/CadastroServicosPacs.vue'),
        props: true,
        meta: {
          interno: true,
          breadcrumb: 'Configurações',
          perfil: 6
        }
    },
    {
        path: '/config/promedsys',
        name: 'c-promed-sys',
        component: () => import('./components/cadastros/items/PromedSys.vue'),
        props: true,
        meta: {
          interno: true,
          breadcrumb: 'Configurações',
          perfil: 6
        }
    },
    {
        path: '/config/configuracoes-pagamento',
        name: 'c-config-pagamentos',
        component: () => import('./components/cadastros/items/CadastroServicosPagamentos.vue'),
        props: true,
        meta: {
          interno: true,
          breadcrumb: 'Configurações',
          perfil: 6
        }
    },
    {
        path: '/config/configuracoes-cobranca',
        name: 'c-config-cobranca',
        component: () => import('./components/cadastros/items/CadastroServicosCobranca.vue'),
        props: true,
        meta: {
          interno: true,
          breadcrumb: 'Configurações',
          perfil: 6
        }
    },
    // Reembolso...

    {
      path: '/reembolso/logins',
      name: 'reembolso-logins',
      component: () => import('./components/modulos/reembolso/LoginEnviado.vue'),
      meta: {
        interno: true,
        perfil: 18,
      },
    },

    {
      path: '/reembolso/bradesco/',
      name: 'reembolso-bradesco',
      component: () => import('./components/portal/IdentificacaoReembolso.vue'),
      meta: {
        externo: true,
        bradesco: true,
      },
    },

    {
      path: '/reembolso/:aba',
      name: 'reembolso',
      props: true,
      component: () => import('./components/modulos/reembolso/ModuloReembolso.vue'),
      meta: {
        interno: true,
        perfil: 18,
      },
    },

    {
      path: '/config/status-reembolso',
      name: 'c-status-reembolso',
      component: () => import('./components/cadastros/items/CadastroContatoStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'atendimento',
        titulo: 'Reembolso'
      },
    },

    // Tempos...

    {
      path: '/tempos/:aba',
      name: 'tempos',
      props: true,
      component: () => import('./components/modulos/tempos/ModuloTempos.vue'),
      meta: {
        interno: true,
        perfil: 29,
      },
    },

    // Centro Cirurgico...

    {
      path: '/centro-cirurgico/:aba',
      name: 'centro-cirurgico',
      props: true,
      component: () => import('./components/modulos/centrocirurgico/ModuloCentroCirurgico.vue'),
      meta: {
        interno: true,
        perfil: 24,
      },
    },

    {
      path: '/centro-cirurgico/historico/:id/:fila?',
      name: 'centro-cirurgico-pep',
      component: () => import('./components/modulos/consultorio/PEP.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 24,
        enfermagem: true,
        cc: true, 
      }
    },

    {
      path: '/centro-cirurgico/atendimento/:id/:fila?',
      name: 'centro-cirurgico-res',
      component: () => import('./components/modulos/consultorio/PepItem.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 24,
        enfermagem: true,
        cc: true, 
      }
    },

    {
      path: '/infusao/:aba',
      name: 'infusao',
      props: true,
      component: () => import('./components/modulos/infusao/ModuloDeInfusao.vue'),
      meta: {
        interno: true,
        perfil: 25,
      },
    },

    // Rotas de Laudos...

    {
      path: '/laudos/config',
      name: 'laudos-config',
      component: () => import('./components/modulos/consultorio/ConsultorioConfig.vue'),
      meta: {
        interno: true,
        perfil: 13,
      }
    },
    {
      path: '/laudos/visao',
      name: 'laudos-visao',
      component: () => import('./components/modulos/laudos/LaudosVisaoGeral.vue'),
      meta: {
        interno: true,
        perfil: 13,
      },
    },
    {
      path: '/laudos/lista',
      name: 'laudos-lista',
      component: () => import('./components/modulos/laudos/ListaDeTrabalho.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 13,
      },
    },
    {
      path: '/laudos/ocorrencias',
      name: 'laudos-ocorrencias',
      component: () => import('./components/modulos/laudos/LaudoOcorrencias.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 13,
      },
    },
    {
      path: '/laudos/amostras',
      name: 'laudos-amostras',
      component: () => import('./components/modulos/laudos/LaudoAmostras.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 13,
      },
    },
    {
      path: '/laudos/:id/:fila?',
      name: 'laudo',
      component: () => import('./components/modulos/laudos/Laudo.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 13,
      },
    },

    // Rotas de Escalas...

    {
      path: '/escalas/:aba?',
      name: 'escalas',
      component: () => import('./components/modulos/escalas/ModuloDeEscalas.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 20,
      },
    },

    // Rotas de Laboratório...

    {
      path: '/laboratorio/:aba?',
      name: 'laboratorio',
      component: () => import('./components/modulos/laboratorio/ModuloDeLaboratorio.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 22,
      },
    },

    // Rotas de Enfermagem...

    {
      path: '/assistencia/:aba?',
      name: 'assistencia',
      component: () => import('./components/modulos/enfermagem/ModuloEnfermagem.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 14,
      },
    },
    {
      path: '/assistencia/historico/:id/:fila?/:id_atend?',
      name: 'assistencia-pep',
      component: () => import('./components/modulos/consultorio/PEP.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 14,
        enfermagem: true
      }
    },
    {
      path: '/assistencia/atendimento/:id/:fila?',
      name: 'assistencia-res',
      component: () => import('./components/modulos/consultorio/PepItem.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 14,
        enfermagem: true
      }
    },
    {
      path: '/assistencia/pre/:id/:fila?',
      name: 'assistencia-pre',
      component: () => import('./components/modulos/enfermagem/PreAtendimentoEnfermagem.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 14,
      }
    },

    // Nutrição...

    {
      path: '/nutricao/:aba',
      name: 'nutricao',
      component: () => import('./components/modulos/nutricao/ModuloNutricao.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Nutrição',
        perfil: 30
      }
    },

    // Contabilidade...

    {
      path: '/contabilidade/:aba',
      name: 'contabilidade',
      component: () => import('./components/modulos/contabilidade/ModuloContabil.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Contabilidade',
        perfil: 27
      }
    },

    // Vacina...

    {
      path: '/vacina',
      name: 'vacina',
      component: () => import('./components/modulos/vacina/ModuloVacina.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Vacina',
        perfil: 21
      }
    },

    {
      path: '/vacina/atendimento/:id/:fila?',
      name: 'vacina-atend',
      component: () => import('./components/modulos/consultorio/PepItem.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Vacina',
        perfil: 21,
        vacina: true
      }
    },
    {
      path: '/vacina/historico/:id/:fila?',
      name: 'vacina-pep',
      component: () => import('./components/modulos/consultorio/PEP.vue'),
      props: true,
      meta: {
        interno: true,
        perfil: 21,
        vacina: true
      }
    },

    // Zerodox

    {
      path: '/config/zerodox-depara',
      name: 'c-zerodox-depara',
      component: () => import('./components/cadastros/items/CadastroZerodoxDocDepara.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
      },
    },

    // Internação...

    {
      path: '/config/tipo-bloqueio-leito',
      name: 'c-tipo-bloqueio-leito',
      component: () => import('./components/cadastros/items/CadastroTipoBloqueioLeito.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
      },
    },

    // Rotas de Configurações...

    {
      path: '/config/construcao',
      name: 'c-construcao',
      component: () => import('./components/cadastros/items/Construcao.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações'
      }
    },
    {
      path: '/cadastros',
      name: 'cadastros',
      component: () => import('./components/cadastros/Cadastros.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/ocorrencia-laudo',
      name: 'c-ocorrencias-laudos',
      component: () => import('./components/cadastros/items/CadastroContatoStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'laudo',
        titulo: '...Tipos de Ocorrências de Laudos'
      },
    },
    {
      path: '/config/recursos',
      name: 'c-recursos',
      component: () => import('./components/cadastros/items/CadastroDeRecurso.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/modelodistcc',
      name: 'c-modelodistcc',
      component: () => import('./components/cadastros/items/CadastroModeloDistCentroCusto.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/apoiados',
      name: 'c-apoiados',
      component: () => import('./components/cadastros/items/CadastroApoiados.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/apoiadoportalabas',
      name: 'c-apoiadoportalabas',
      component: () => import('./components/cadastros/items/CadastroApoiadoPortalAba.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/permissoes',
      name: 'c-permissoes',
      component: () => import('./components/cadastros/CadastroPermissoes.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
        path: '/config/atalhos',
        name: 'c-atalhos',
        component: () => import('./components/cadastros/items/CadastroAtalhos.vue'),
        meta: {
          interno: true,
          breadcrumb: 'Configurações',
          perfil: 6
        }
      },
    {
      path: '/config/horario-acessos',
      name: 'c-horario-acessos',
      component: () => import('./components/cadastros/items/CadastroHorarioAcessos.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/clinica',
      name: 'c-clinica',
      component: () => import('./components/cadastros/items/Clinicas.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/prestadores/:id_medico?',
      name: 'c-prestadores',
      component: () => import('./components/cadastros/items/Prestadores.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/especialidades',
      name: 'c-especialidades',
      component: () => import('./components/cadastros/items/CadastroEspecialidades.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/procedimentos/:id_procedimento?',
      name: 'c-procedimentos',
      component: () => import('./components/cadastros/items/CadastroProcedimentos.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/pacote-sessoes',
      name: 'c-pacote-sessoes',
      component: () =>
        import('./components/cadastros/items/CadastroPacoteDeSessoes.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/combos',
      name: 'c-combo-procedimentos',
      component: () => import('./components/cadastros/items/CadastroComboDeProcedimentos.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/valores-particulares',
      name: 'c-valores-particulares',
      props: true,
      component: () => import('./components/cadastros/items/ValoresParticulares.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/instrucoes-particulares',
      name: 'c-instrucoes-particulares',
      props: true,
      component: () => import('./components/cadastros/items/InstrucoesParticulares.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/forma-pagamento',
      name: 'c-forma-pagamento',
      component: () => import('./components/cadastros/items/CadastroFormasDePagamento.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/prof-solicitante',
      name: 'c-medico-solicitante',
      props: true,
      component: () => import('./components/cadastros/items/CadastroMedicoSolicitante.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/centros-cirurgicos',
      name: 'c-centro-cirurgico',
      props: true,
      component: () => import('./components/cadastros/items/CadastroCentrosCirurgicos.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/terceiros',
      name: 'c-terceiros',
      props: true,
      component: () => import('./components/cadastros/items/CadastroTerceiros.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/terceiros-depara',
      name: 'c-terceiros-depara',
      props: true,
      component: () => import('./components/cadastros/items/CadastroTerceiroProcedimentos.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/regra-rateio',
      name: 'c-regra-rateio',
      props: true,
      component: () => import('./components/cadastros/items/CadastroRateioMedico.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/teto-atendimento',
      name: 'c-teto-atendimento',
      props: true,
      component: () => import('./components/cadastros/items/CadastroTetoAtendimento.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/grupos-chat',
      name: 'c-grupos-chat',
      props: true,
      component: () => import('./components/cadastros/items/CadastroChatSalaGrupo.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/oferta-particular',
      name: 'c-oferta-particular',
      props: true,
      component: () => import('./components/cadastros/items/CadastroOfertaParticular.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/regiao',
      name: 'c-regiao-cd',
      props: true,
      component: () => import('./components/cadastros/items/CadastroRegiaoCD.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/rota-etq',
      name: 'c-rota-etqs',
      props: true,
      component: () => import('./components/cadastros/items/CadastroRotaEtqs.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/sinonimos',
      name: 'c-sinonimos',
      props: true,
      component: () => import('./components/cadastros/items/CadastroSinonimos.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/cuidado-programa',
      name: 'c-cuidado-programa',
      props: true,
      component: () => import('./components/cadastros/items/CadastroCuidadoPrograma.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/grupo-atendimento',
      name: 'c-tarefa-grupos',
      props: true,
      component: () => import('./components/cadastros/items/CadastroTarefaGrupo.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/sociedades',
      name: 'c-sociedades',
      component: () => import('./components/cadastros/items/CadastroSociedadeMedica.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/modalidade-dicom',
      name: 'c-modalidade-dicom',
      props: true,
      component: () => import('./components/cadastros/items/CadastroModalidadeDicom.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/tipo-observacao',
      name: 'c-observacao-tipo',
      props: true,
      component: () => import('./components/cadastros/items/CadastroObservacaoTipo.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/alcada-desconto',
      name: 'c-alcada-desconto',
      props: true,
      component: () => import('./components/cadastros/items/CadastroDescontoTipo.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/sinalzador',
      name: 'c-sinalizador-atendimento',
      props: true,
      component: () => import('./components/cadastros/items/CadastroSinalizador.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/sinalzador/:model',
      name: 'c-sinalizador-gen',
      props: true,
      component: () => import('./components/cadastros/items/CadastroSinalizadorGen.vue'),
      meta: {
        props: true,  
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/mensagem',
      name: 'c-mensagem',
      props: true,
      component: () => import('./components/cadastros/items/CadastroMensagens.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/texto-padrao',
      name: 'c-texto-padrao',
      props: true,
      component: () => import('./components/cadastros/items/CadastroTextoPadrao.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/agendas',
      name: 'c-agendas',
      props: true,
      component: () => import('./components/cadastros/items/CadastroAgendas.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/agendas-compartilhadas',
      name: 'c-agendas-compartilhadas',
      props: true,
      component: () => import('./components/cadastros/items/CadastroAgendaCompartilhada.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/campanhas',
      name: 'c-campanhas',
      props: true,
      component: () => import('./components/cadastros/items/CadastroCampanhas.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/feriados',
      name: 'c-feriados',
      props: true,
      component: () => import('./components/cadastros/items/CadastroFeriados.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/operadoras/:id_operadora?/:go_submenu?',
      name: 'c-operadoras',
      props: true,
      component: () => import('./components/cadastros/items/CadastroOperadoras.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/contrato-operadoras',
      name: 'c-contrato-operadoras',
      props: true,
      component: () => import('./components/cadastros/items/CadastroContratoOperadora.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/status-nps',
      name: 'c-status-nps',
      component: () => import('./components/cadastros/items/CadastroContatoStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'marcacao',
        titulo: 'Retorno de NPS'
      },
    },
    {
      path: '/config/nps-comunicacao',
      name: 'c-nps-comunicacao',
      props: true,
      component: () => import('./components/cadastros/items/CadastroComunicacaoNps.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/restricoes',
      name: 'c-restricoes',
      props: true,
      component: () => import('./components/cadastros/items/Operadora/Restricoes.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/avisos',
      name: 'avisos',
      props: true,
      component: () => import('./components/cadastros/ConfigAvisos.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
      }
    },
    {
      path: '/config/material-amostra',
      name: 'c-material-amostra',
      props: true,
      component: () => import('./components/cadastros/items/CadastroAmostraMaterial.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/status-amostra-rastreabilidade',
      name: 'c-amostra-rastro-status',
      props: true,
      component: () => import('./components/cadastros/items/CadastroAmostraRastroStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/cadastro/:cadastro',
      name: 'c-cadastro',
      props: true,
      component: () => import('./components/cadastros/items/CadastroSimples.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/suprimento-tipo-movimentacao',
      name: 'c-suprimento-tipo-movimentacao',
      props: true,
      component: () => import('./components/cadastros/items/CadastroEstoqueTipoMovimentacao.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/motivos/:local',
      name: 'c-motivo-glosa',
      props: true,
      component: () => import('./components/cadastros/items/CadastroMotivoGlosa.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/motivo/:local',
      name: 'c-motivo',
      props: true,
      component: () => import('./components/cadastros/items/CadastroMotivo.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/unidades-medida',
      name: 'c-unidades-medida',
      component: () => import('./components/cadastros/items/CadastroUnidadeMedida.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/sus-autorizador',
      name: 'c-sus-autorizador',
      component: () => import('./components/cadastros/items/SusAutorizador.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/materiais',
      name: 'c-materiais',
      component: () => import('./components/cadastros/items/CadastroMateriais.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/balanco-hidrico',
      name: 'c-balanco-hidrico',
      component: () => import('./components/cadastros/items/CadastroBalancoHidrico.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/aparelho-internacao',
      name: 'c-internacao-aparelho',
      component: () => import('./components/cadastros/items/CadastroInternacaoAparelho.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/tipo-alergia',
      name: 'c-tipo-alergia',
      component: () => import('./components/cadastros/items/CadastroAlergiaTipo.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/medicamentos',
      name: 'c-medicamentos',
      component: () => import('./components/cadastros/items/CadastroMateriais.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/prescricao-uso',
      name: 'c-prescricao-uso',
      component: () => import('./components/cadastros/items/CadastroPrescricaoUso.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/prescricao-via',
      name: 'c-prescricao-via',
      component: () => import('./components/cadastros/items/CadastroPrescricaoVia.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/tipo-etiqueta-amostra',
      name: 'c-tipo-etiqueta-amostra',
      component: () => import('./components/cadastros/items/CadastroTipoEtiquetaAmostra.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/auto-urg',
      name: 'c-auto-urg',
      component: () => import('./components/cadastros/items/CadastroAutoUrg.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/lab-legado',
      name: 'c-lab-legados',
      component: () => import('./components/cadastros/items/LabLegado.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 22
      }
    },
    {
      path: '/config/painel-imuno',
      name: 'c-painel-imuno',
      component: () => import('./components/cadastros/items/CadastroImunoPainel.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/taxas',
      name: 'c-taxas',
      component: () => import('./components/cadastros/items/CadastroMateriais.vue'),
      props: { taxas: true },
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/kits',
      name: 'c-kits',
      component: () => import('./components/cadastros/items/CadastroMateriais.vue'),
      props: { kits: true },
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/simpro',
      name: 'c-simpro',
      component: () => import('./components/cadastros/items/TabelaSimpro.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/brasindice',
      name: 'c-brasindice',
      component: () => import('./components/cadastros/items/TabelaBrasindice.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/unidades',
      name: 'c-unidades',
      component: () => import('./components/cadastros/items/UnidadesCentroDeCusto.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/unidades/:id_unidade_operacao/cnae',
      name: 'c-unidade-cnae',
      component: () => import('./components/cadastros/items/CadastroCnaeUnidade.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/tabelas/:id_tabela_versao?',
      name: 'c-tabelas',
      component: () => import('./components/cadastros/items/CadastroDeTabelas.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/categorias',
      name: 'c-categorias',
      component: () => import('./components/cadastros/items/CadastroFinanceiroCategorias.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/impostos',
      name: 'c-impostos',
      component: () => import('./components/cadastros/items/CadastroImpostos.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/grupo-procedimento',
      name: 'c-grupo-procedimentos',
      component: () => import('./components/cadastros/items/CadastroProcedimentoGrupo.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/bancos',
      name: 'c-bancos',
      component: () => import('./components/cadastros/items/CadastroFinanceiroBancos.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/contas',
      name: 'c-contas',
      component: () => import('./components/cadastros/items/CadastroFinanceiroContas.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/cadastros/:model/',
      name: 'cadastro',
      component: () => import('./components/cadastros/CadastroPadrao.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Lista',
        perfil: 6
      }
    },
    {
      path: '/config/valid/cadastros',
      name: 'c-valid-links',
      props: true,
      component: () => import('./components/cadastros/validacao/LinkCadastros.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/valid/geral',
      name: 'c-valid-geral',
      props: true,
      component: () => import('./components/cadastros/validacao/ValidGeral.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/valid/faturamento',
      name: 'c-valid-faturamento',
      props: true,
      component: () => import('./components/cadastros/validacao/ValidFaturamento.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/valid/marcacoes',
      name: 'c-valid-marcacoes',
      props: true,
      component: () => import('./components/cadastros/validacao/ValidMarcacoes.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/valid/precos',
      name: 'c-valid-precos',
      props: true,
      component: () => import('./components/cadastros/validacao/ValidPrecos.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/valid/precos-operadora',
      name: 'c-valid-precos-operadora',
      props: true,
      component: () => import('./components/cadastros/validacao/ValidPrecoOperadora.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/duplicidade',
      name: 'c-duplicidade',
      props: true,
      component: () => import('./components/cadastros/items/DuplicidadeDePaciente.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/historico-legado',
      name: 'c-historico-legado',
      props: true,
      component: () => import('./components/cadastros/items/PacienteLegadoManual.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/fila-laudo',
      name: 'c-fila-laudo',
      props: true,
      component: () => import('./components/cadastros/items/CadastroFilaLaudo.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/status-laudo',
      name: 'c-status-laudo',
      props: true,
      component: () => import('./components/cadastros/items/CadastroStatusLaudo.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/status-lista-espera',
      name: 'c-status-lista-espera',
      component: () => import('./components/cadastros/items/CadastroContatoStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'listaEspera',
        titulo: 'Fluxo de Lista de Espera'
      },
    },
    {
      path: '/config/status-autoriz',
      name: 'c-status-solic-autoriz',
      component: () => import('./components/cadastros/items/CadastroContatoStatus.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
        model: 'solicitacaoAutorizacao',
        titulo: 'Fluxo de Autorização'
      },
    },
    {
      path: '/config/fila-proced',
      name: 'c-fila-proced',
      props: true,
      component: () => import('./components/cadastros/items/CadastroFilaLaudo.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
      }
    },
    {
      path: '/config/fila-enferm',
      name: 'c-fila-enferm',
      props: true,
      component: () => import('./components/cadastros/items/CadastroFilaLaudo.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
      }
    },
    {
      path: '/config/fila-vacina',
      name: 'c-fila-vacina',
      props: true,
      component: () => import('./components/cadastros/items/CadastroFilaLaudo.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6,
      }
    },
    {
      path: '/config/cabecalhos',
      name: 'c-cabecalhos',
      props: true,
      component: () => import('./components/cadastros/CadastroCabecalhoLaudo.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/fila-lead',
      name: 'c-fila-lead',
      props: true,
      component: () => import('./components/cadastros/items/CadastroFilaLead.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/fila-autoriz',
      name: 'c-fila-autoriz',
      props: true,
      component: () => import('./components/cadastros/items/CadastroFilaAutorizacao.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/confirmar/:id/:token',
      name: 'confirmar-marcacao',
      component: () => import('./components/modulos/externo/ConfirmaCadastro.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/modelos/:id?',
      name: 'modelos',
      props: true,
      component: () => import('./components/modulos/consultorio/configs/Modelos.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações'
      }
    },
    {
      path: '/enquetes/:id?',
      name: 'enquetes',
      props: true,
      component: () => import('./components/cadastros/items/CadastroEnquetes.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações'
      }
    },
    {
      path: '/modelosdoc',
      name: 'modelos-doc',
      component: () => import('./components/modulos/consultorio/configs/ModelosDoc.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações'
      }
    },
    {
      path: '/certificado',
      name: 'certificado',
      component: () => import('./components/modulos/consultorio/configs/Certificado.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Certificado',
        // perfil: 7
      }
    },
    {
      path: '/medicamentos',
      name: 'medicamentos',
      component: () => import('./components/modulos/consultorio/configs/MedicamentosReceita.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Medicamentos',
      }
    },
    {
      path: '/procedimentos',
      name: 'procedimentos',
      component: () => import('./components/modulos/consultorio/configs/ProcedimentosRequisicao.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Procedimentos',
      }
    },
    {
      path: '/kit/:tipo',
      name: 'kit',
      component: () => import('./components/modulos/consultorio/configs/OrderSetKit.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Kit',
      }
    },
    {
      path: '/config/campos',
      name: 'c-config-campos',
      component: () => import('./components/cadastros/items/CadastroCamposPaciente.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/etiquetas',
      name: 'c-config-etiquetas',
      component: () => import('./components/cadastros/items/CadastroLayoutEtiqueta.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/anexos',
      name: 'c-config-anexos',
      component: () => import('./components/cadastros/items/CadastroAnexoRequerido.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/layout-importacoes',
      name: 'c-config-layout-importacoes',
      component: () => import('./components/cadastros/items/CadastroLayoutImportacao.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/layout-exportacoes',
      name: 'c-config-layout-exportacoes',
      component: () => import('./components/cadastros/items/CadastroLayoutExportacao.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/layout-cartao-credito',
      name: 'c-config-layout-cartao-credito',
      component: () => import('./components/cadastros/items/CadastroLayoutCartaoCredito.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/layout-arquivo-retorno',
      name: 'c-config-layout-arquivo-retorno',
      component: () => import('./components/cadastros/items/CadastroLayoutArquivoRetorno.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/outras',
      name: 'c-outras-config',
      component: () => import('./components/cadastros/items/CadastroParametros.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/paciente-campos-obrig',
      name: 'c-pac-campos-obrig',
      component: () => import('./components/cadastros/items/CadastroPacCamposObrig.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/usuarios',
      name: 'c-usuarios',
      component: () => import('./components/cadastros/items/CadastroUsuarios.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/config/autorizar-maquina',
      name: 'c-aut-maquina',
      component: () => import('./components/cadastros/items/AutorizarMaquina.vue'),
      props: true,
      meta: {
        interno: true,
        breadcrumb: 'Configurações',
        perfil: 6
      }
    },
    {
      path: '/audits', // /:model/:id
      name: 'audits',
      component: () => import('./components/shared/audit/Auditoria.vue'),
      props: true,
      meta: {
        interno: true,
      }
    },
    {
      path: '/redefinirsenha/:id/:token',
      name: 'redefinirsenha',
      component: () => import('./components/LoginRedefinirSenha.vue'),
      props: true,
      meta: {
        externo: true
      },
    },

    // Acesso Externo...
    {
      path: '/pagamento',
      name: 'c-pagamento',
      props: true,
      component: () => import('./components/shared/pagamento/PagamentoOnline.vue'),
      meta: {
        interno: true,
        breadcrumb: 'Pagamento',
      }
    },

    {
      path: '/painel/:token?/:unidade?/:video?/:codigo?',
      name: 'painel-chamada',
      component: () => import('./components/painel/Chamada.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/novocadastro/:id_recepcao/:id_adicao?',
      name: 'novocadastro',
      component: () => import('./components/modulos/externo/NovoCadastro.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/meucadastro',
      name: 'meucadastro',
      component: () => import('./components/modulos/externo/ConfirmaCadastro.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/resultados',
      name: 'resultados',
      component: () => import('./components/portal/PortalResultados.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/portalinfo',
      name: 'portalinfo',
      component: () => import('./components/portal/PortalInfo.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/portaldownload',
      name: 'portaldownload',
      component: () => import('./components/portal/PortalDownloadResultado.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/apoiorelats',
      name: 'apoiorelats',
      component: () => import('./components/portal/PortalRelatorios.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/apoiorelat',
      name: 'apoiorelat',
      component: () => import('./components/portal/PortalRelatorio.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/apoiocadastro',
      name: 'apoiocadastro',
      component: () => import('./components/portal/PortalApoioCadastro.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/pa/:id',
      name: 'apoiadoaba',
      component: () => import('./components/portal/PortalApoiadoAba.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/apoioresultados',
      name: 'apoioresultados',
      component: () => import('./components/portal/PortalResultadosApoiado.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/portal/operadora',
      name: 'portal-operadora',
      component: () => import('./components/portal/PortalOperadora.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/marcar/',
      name: 'marcar',
      component: () => import('./components/portal/MarcacaoOnLine.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/tm/',
      name: 'teleatendimento',
      component: () => import('./components/portal/PortalTeleAtendimento.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/videochamada/:sala/:token/:id_marcacao?',
      name: 'videochamada',
      component: () => import('./components/portal/VideoCallDireto.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/preatendimento/:sala/:token/:id_marcacao?',
      name: 'preatendimento',
      component: () => import('./components/portal/VideoCallDireto.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/infoatend/:sala/:token/:id_marcacao?',
      name: 'link-atendimento',
      component: () => import('./components/portal/VideoCallDireto.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/consentimento/:id_marcacao/:token/',
      name: 'consentimento',
      component: () => import('./components/portal/TermoConsentimento.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/atend/:id_marcacao/:token/:action?',
      name: 'resumo-atendimento',
      component: () => import('./components/portal/VideoCallDireto.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/fileuploadmobile/:token?',
      name: 'fileupload-mobile',
      component: () => import('./components/painel/FileUploadMobile.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/reembolso/credenciais/:tipo/:id/:token',
      name: 'reembolso-credenciais',
      component: () => import('./components/portal/ReembolsoCredencial.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/resultado/exames/:laboratorio/:id/:token',
      name: 'resultado-exames',
      component: () => import('./components/portal/ResultadoCredenciais.vue'),
      meta: {
        externo: true
      },
      props: true
    },
    {
      path: '/setup/:aba',
      name: 'setup',
      component: () => import('./components/setup/SetupInicial.vue'),
      meta: {
        interno: true,
        breadcrumb: "Configuração Inicial"
      },
      props: true
    },
    {
      path: '/pesquisa-clinica/:aba?',
      name: 'pesquisa',
      component: () => import('./components/modulos/pesquisa/ModuloDePesquisaClinica.vue'),
      meta: {
        interno: true,
        breadcrumb: "Pesquisa Clínica",
        perfil: 23
      },
      props: true
    },
    {
      path: '/recepcao/:id?',
      name: 'recepcao',
      component: () =>
        import('./components/modulos/recepcao/ModuloRecepcao.vue'),
      meta: {
        interno: true,
        perfil: 4
      }
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// add the beforeEach hook
router.beforeEach((to, from, next) => {
  if (!util.check_perfil(store.state.user, to.meta.perfil, to.path)) {
    window.app.$toast.add({
      severity: "error",
      summary: "Acesso Negado",
      detail: "Acesso negado a " + to.path,
      life: 3000
    });
    next({ path: '/' });
  } else {
    // $('.tooltip').tooltip('hide');
    next();
    $('.tooltip').tooltip('hide');
  }
});

router.onError(error => {
  console.log('router', error.message);

  if (/chunk/i.test(error.message) && /failed/i.test(error.message) && navigator.onLine) {
    if ( confirm('Falha no carregamento da aplicação. Necessário atualizar a página.') ) {
      window.location.reload();
    }
  }
});

export default router;
